// ProductMoreInfo.jsx
import React from "react";

export default function ProductMoreInfo({ isMobile }) {
  return (
    <div>
      {/* TABS */}
      <div
        style={{
          display: "flex",
          gap: isMobile ? "10px" : "15px",
          marginTop: "40px",
          flexWrap: "wrap",
          justifyContent: isMobile ? "center" : "flex-start",
        }}
      >
        <button style={activeTab}>Description</button>
        {/* <button style={tab}>Reviews</button>
        <button style={tab}>Resources</button> */}
      </div>

      {/* FULL DESCRIPTION */}
      <p style={{ marginTop: "20px" }}>
       Cocoa powder is a key ingredient in the food and beverage industry, valued for its bold flavour, rich colour, and versatility. It is produced by pressing the fat 
(cocoa butter) out of roasted cocoa beans and grinding the remaining solids into a fine powder. Cocoa powder comes in two main types—natural 
(slightly acidic and bitter) and alkalized/Dutch-processed (smoother, less acidic, and darker in colour).
      </p>

      <h3>Key Features:</h3>
      <ul>
        <li>Deep chocolate aroma and taste</li>
        <li>Available in natural or alkalized (Dutch-processed) form</li>
        <li>Low fat and versatile for culinary use</li>
        <li>Long shelf life</li>
      </ul>

      <h3>Nutritional Benefits:</h3>
      <ul>
        <li>Baking (cakes, brownies, cookies)
Chocolate beverages and milkshakes</li>
        <li>Confectionery and desserts</li>
        <li>Protein shakes and health supplements</li>
      </ul>  

      <h3>Applications:</h3>
      <ul>
      <li>Rich in antioxidants (flavonoids)</li>
      <li>Contains iron, magnesium, and fibre</li>
      <li>Low in sugar and carbohydrates, Supports heart and brain health</li>
      </ul>

      <h3>Advantages:</h3>
      <ul>
        <li>Enhances flavour without added sugar</li>
        <li>Suitable for vegan and gluten-free diets</li>
        <li>Helps improve mood and energy levels</li>
        <li>Easy to store and use in a variety of recipes</li>
      </ul>
    </div>
  );
}

const activeTab = {
  padding: "10px 20px",
  background: "green",
  color: "white",
  borderRadius: "8px",
  border: "none",
};

const tab = {
  padding: "10px 20px",
  borderRadius: "8px",
  border: "1px solid #ccc",
};
